export function TokenCheck(): boolean {
    try {
        const token = localStorage.getItem('token');
        //console.log("token bool > " + !!token)
        //console.log("token > " + token)
        return !!token;
    } catch (error) {
        return false;
    }
}